import { Container, Nav, NavItem } from 'reactstrap';
import { Route, Switch } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faMapMarkedAlt, faExchangeAlt, faPhone, faClipboardList,
    faTruckArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import { NavLink } from '@s20/components/common/Link';
import { AppNavPaths } from '../Common';
import { Can } from '../Can';
import AuthorizeRoute from '../api-authorization/AuthorizeRoute';
import CallLogIndex from './CallLog/CallLogIndex';
import { DispatchPlusMap } from './DispatchPlusMap';
import { DispatchPlusHandoff } from './DispatchPlusHandoff';
import JobRequestIndex from './JobRequests';
import { Dispatch } from './Dispatch';

export const DispatchPlus = () => (
    <Container
        fluid
        className="site-page-wrap pt-3 d-flex flex-column"
    >
        <Nav
            tabs
            className="mb-2 pb-3 dispatch-plus-nav"
        >
            <NavItem>
                <NavLink
                    className="nav-link"
                    to={AppNavPaths.DispatchPlusDispatch}
                >
                    <FontAwesomeIcon
                        icon={faTruckArrowRight}
                        className="mr-2 text-muted"
                    />

                    <span>Dispatch</span>
                </NavLink>
            </NavItem>

            <NavItem>
                <NavLink
                    className="nav-link"
                    to={AppNavPaths.DispatchPlusHandoff}
                >
                    <FontAwesomeIcon
                        icon={faExchangeAlt}
                        className="mr-2 text-muted"
                    />
                    <span>Hand Off</span>
                </NavLink>
            </NavItem>

            <NavItem>
                <NavLink
                    className="nav-link"
                    to={AppNavPaths.DispatchPlusMap}
                >
                    <FontAwesomeIcon
                        icon={faMapMarkedAlt}
                        className="mr-2 text-muted"
                    />
                    <span>Map</span>
                </NavLink>
            </NavItem>

            <Can
                I="view"
                a="call_log"
            >
                <NavItem>
                    <NavLink
                        className="nav-link"
                        to={AppNavPaths.DispatchPlusCallLog}
                    >
                        <FontAwesomeIcon
                            icon={faPhone}
                            className="mr-2 text-muted"
                        />
                        <span>Call Log</span>
                    </NavLink>
                </NavItem>
            </Can>

            <Can
                I="view"
                a="job_request"
            >
                <NavItem>
                    <NavLink
                        className="nav-link"
                        to={AppNavPaths.DispatchPlusJobRequest}
                    >
                        <FontAwesomeIcon
                            icon={faClipboardList}
                            className="mr-2 text-muted"
                        />
                        <span>Job Requests</span>
                    </NavLink>
                </NavItem>
            </Can>
        </Nav>

        <Switch>
            <Route
                path={AppNavPaths.DispatchPlusHandoff}
                exact
                component={DispatchPlusHandoff}
            />

            <Route
                path={AppNavPaths.DispatchPlusMap}
                exact
                component={DispatchPlusMap}
            />

            <AuthorizeRoute
                path={AppNavPaths.DispatchPlusCallLog}
                exact
                component={CallLogIndex}
                perm="call_log"
                action="view"
            />

            <AuthorizeRoute
                path={AppNavPaths.DispatchPlusJobRequest}
                exact
                component={JobRequestIndex}
                perm="job_request"
                action="view"
            />

            <AuthorizeRoute
                path={AppNavPaths.DispatchPlusDispatch}
                exact
                component={Dispatch}
                perm="dispatch"
                action="view"
            />
        </Switch>
    </Container>
);